/**
 * Created by sswaminathan on 2/8/22
 * File: SplashScreen
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Body } from '@panwds/react-table'
import { Button, Card, CardBody, CardFooter, Tooltip } from '@panwds/react-ui'
/**
 *   TODO: Brief what is this component/class do
 */
import { useCallback } from 'react'
import './splashScreen.scss'
import { CloudImg } from '../../../common/assets/images'
import { setUserFlow } from '../../../common/reducers/actions/LicenseReducer.actions'
import {
  PANORAMA_LINK,
  USER_FLOW_MULTI,
  USER_FLOW_SINGLE,
  ENTERPRISE,
  MSP,
  WELCOME_TEXT_1,
  CLOUD_MANAGEMENT, TOOLTIP_ST_BUTTON, TOOLTIP_MT_BUTTON
} from '../constants/SubscriptionConstant'
import SplashFooter from './SplashFooter'
import PaloAltoNetworks from './PaloAltoNetworks'


const SplashScreen = ({ setContinueMsp, setPanorama, setActivationFlow, dispatch, licenseDispatch }) => {

  const switchToPanorama = useCallback(() => {
    //sessionStorage.setItem('USER_FLOW', USER_FLOW_SINGLE)
    licenseDispatch(setUserFlow(USER_FLOW_SINGLE))
    setActivationFlow((prev) => {
      return ENTERPRISE
    })
    setPanorama({ isPanoramaLocked: true })
  }, [licenseDispatch, setActivationFlow, setPanorama])
  const continueMspFlow = useCallback(() => {
    licenseDispatch(setUserFlow(USER_FLOW_MULTI))
    //sessionStorage.setItem('USER_FLOW', USER_FLOW_MULTI)
    setActivationFlow((prev) => {
      return MSP
    })
  }, [licenseDispatch, setActivationFlow])

  return (<div className='splashScreen'>
    <div className='splashMain tw-h-full tw-block tw-flex tw-flex-col tw-justify-center tw-items-center'>
      <Card style={{ width: '448px', height: '504px' }}>
        <CardBody addClassName='tw-h-full'>
          <div className='tw-flex tw-flex-col tw-h-full'>
            <PaloAltoNetworks />
            <div className='tw-flex-grow tw-flex tw-flex-col tw-mt-6 tw-items-center'>
              <div className='tw-mt-4 tw-pb-4'>
                <img style={{ width: '117px', height: '117px' }}
                  className='tw-ml-4'
                  src={CloudImg} alt={'cloudimg'} />
              </div>
              <div className='tw-mt-4 tw-pb-4 tw-text-center'>
                {/*<Body className='tw-ml-4' style={{ fontSize: '20px' }}>{WELCOME_TEXT_1}<br/>{WELCOME_TEXT_2}</Body>*/}
                <Body className='tw-ml-4' style={{ fontSize: '20px' }}>{WELCOME_TEXT_1}</Body>
              </div>
            </div>
          </div>
        </CardBody>
        <CardFooter addClassName='tw-pt-4 tw-pb-6' appearance="clear" style={{ borderTop: '1px solid rgb(0, 0, 0,0.1)', justifyContent: 'center' }}>
          <div className='tw-flex tw-flex-col'>
            <Tooltip label={TOOLTIP_ST_BUTTON}>
              <Button addClassName='tw-mb-2 tw-justify-center' appearance="primary" onClick={switchToPanorama}>{PANORAMA_LINK}</Button>
            </Tooltip>
            <Tooltip label={TOOLTIP_MT_BUTTON}>
              <Button addClassName='tw-justify-center tw-w-full ' appearance="primary" onClick={continueMspFlow}>{CLOUD_MANAGEMENT}</Button>
            </Tooltip>
          </div>
        </CardFooter>
      </Card>
      {/*<div className='tw-mt-2'>*/}
      {/*  <Link onClick={switchToPanorama}>{PANORAMA_LINK}</Link>*/}
      {/*</div>*/}
    </div>
    <div className='splashFooter tw-flex tw-flex-row'>
      <SplashFooter showLogo={true} showSignature={true}/>
    </div>
  </div>)
}
SplashScreen.propTypes = {}
export default SplashScreen
